import { render, staticRenderFns } from "./submitreport.vue?vue&type=template&id=5b7b7008&scoped=true&"
import script from "./submitreport.vue?vue&type=script&lang=js&"
export * from "./submitreport.vue?vue&type=script&lang=js&"
import style0 from "./submitreport.vue?vue&type=style&index=0&id=5b7b7008&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b7008",
  null
  
)

export default component.exports